import { useEffect, useRef, useState, useContext, } from 'react';
// 组件
import IconFont from '../../../../../IconFont';
// 方法
import classnames from 'classnames';
import { useLocation, useNavigate, } from 'react-router-dom';
import LayoutContext from '../../../../context/LayoutContext';
// 常量
import {
  DEFAULT_MODULE_ICON,
  DEFAULT_PAGE_ICON,
} from '../../../../../constants/constant';
import './style.less';

export interface IMenuItem {
  /** 名称 */
  name: string;
  /** 路径 */
  path?: string;
  /** 模块 */
  mode?: string;
  /** 图标 */
  icon?: string;
  /** 页面id */
  resourceId?: string;
  /** 是否显示 */
  displayState?: boolean;
  /** 子节点 */
  children?: IMenuItem[];
  [key: string]: any;
}
export interface MenuListProps {
  menuData: IMenuItem[];
  visible?: boolean;
  // 取消
  onCancel: () => void;
}
const PAGE_MENU_WIDTH = 200;
const MenuList: React.FC<MenuListProps> = props => {
  const { menuData, visible, onCancel } = props;
  const [menuWidth, setMenuWidth] = useState<number>(PAGE_MENU_WIDTH);
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const menuRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    global: { skinType },
  } = useContext(LayoutContext);
  // 计算菜单需要展示的宽度，最大支持3倍宽度
  useEffect(() => {
    if (menuRef.current && containerRef.current) {
      const menuHeight = menuRef.current.offsetHeight;
      if (
        containerRef.current.children.length <= 1 ||
        containerRef.current.offsetHeight < menuHeight
      ) {
        setMenuWidth(PAGE_MENU_WIDTH);
      } else {
        const childrenNode: Element[] = Array.from(
          containerRef.current.children,
        );
        let leftHeight: number = 0;
        let rightHeight: number = 0;
        childrenNode.forEach((item: Element, index: number) => {
          const children = item as HTMLDivElement;
          const childrenHeight = children.offsetHeight;
          if (index % 2) {
            rightHeight += childrenHeight;
          } else {
            leftHeight += childrenHeight;
          }
        });
        const maxHeight: number =
          leftHeight > rightHeight ? leftHeight : rightHeight;
        if (maxHeight > menuHeight) {
          setMenuWidth(3 * PAGE_MENU_WIDTH);
        } else {
          setMenuWidth(2 * PAGE_MENU_WIDTH);
        }
      }
    }
  }, [menuData]);
  const handleRoutePush = (url?: string) => {
    if (!url) return;
    navigate(url);
    onCancel && onCancel();
  };

  return (
    <>
      <div
        className="contain-modal"
        style={{ display: visible ? 'block' : 'none' }}
        onClick={onCancel}
      ></div>
      <div
        ref={menuRef}
        className={`tl-menu ${skinType}`}
        style={visible ? { width: `${menuWidth}px` } : { display: 'none' }}
      >
        <div ref={containerRef} className="tl-menu-container">
          {Array.isArray(menuData) &&
            menuData.map(item => {
              const { children } = item;
              if (Array.isArray(children) && children.length) {
                return (
                  <div key={item.resourceId || item.path} className="tl-menu-submenu">
                    <div className={`tl-menu-submenu-title ${skinType}`}>
                      <span className="tl-menu-submenu-title-icon">
                        <IconFont type={item.icon || DEFAULT_MODULE_ICON} />
                      </span>
                      <span>{item.name}</span>
                    </div>
                    <div>
                      {children.map(v => {
                        if (!v.displayState) return null;
                        const classess = classnames('tl-menu-submenu-item', {
                          active: v.path === pathname,
                          [skinType]: skinType,
                        });
                        return (
                          <div
                            key={v.resourceId || v.path}
                            className={classess}
                            onClick={() => handleRoutePush(v.path)}
                            title={v.name}
                          >
                            <span className="tl-menu-submenu-item-icon">
                              <IconFont type={v.icon || DEFAULT_PAGE_ICON} />
                            </span>
                            <span>{v.name}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              }
              const classess = classnames('tl-menu-item', {
                active: item.path === pathname,
                [skinType]: skinType,
              });
              return (
                <div
                  key={item.resourceId || item.path}
                  className={classess}
                  onClick={() => handleRoutePush(item.path)}
                  title={item.name}
                >
                  <span className="tl-menu-item-icon">
                    <IconFont type={item.icon || DEFAULT_PAGE_ICON} />
                  </span>
                  <span>{item.name}</span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

MenuList.defaultProps = {
  visible: false,
};

export default MenuList;
